import React, { useRef, useState } from "react";
import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormLabel,
    Heading,
    Input,
    Text,
    VStack,
    InputGroup,
    InputRightElement,
    Select,
} from "@chakra-ui/react";
import DateOfBirthSelect from '../DateOfBirthSelect';
import { servicebookingFlowStore } from '../../store/ServiceBookingFlowStore';
import { useForm, Controller } from "react-hook-form";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import axios from "axios";
import dayjs from "dayjs";
import { patientStore } from "../../store/PatientStore";
import { useAuth } from '../../services/AuthContext';
// import {
//     usePatientLazyQuery,
// } from "../../graphql/types-and-hooks";
import { useBookAppointmentStore } from "../../store";
import { authStore } from '../../store/AuthStore';
import { useAlert } from '../AlertProvider';


const Step11_ServiceLogin: React.FC = () => {
    const [step, setStep] = useState(1);
    const [challengeId, setChallengeId] = useState<string | null>(null);

    const [agreed, setAgreed] = useState(false); // new state for checkbox
    // eslint-disable-next-line
    const [patient, doctor, setData, resetData] = useBookAppointmentStore(
        (state) => [state.patient, state.doctor, state.setData, state.resetData]
    );

    // eslint-disable-next-line
    const { control, handleSubmit, getValues, formState: { isValid } } = useForm({
        mode: 'onChange',
        defaultValues: {
            mobileNumber: '',
        },
    });


    const { login } = useAuth();
    const [email, setEmail] = useState("");
    const [code, setCode] = useState(["", "", "", "", "", ""]);
    const codeInputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const [userDetails, setUserDetails] = useState({
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
    });
    const [isPhoneSubmitting, setIsPhoneSubmitting] = useState(false);

    const [verificationError, setVerificationError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { showAlert: showPopUpAlert } = useAlert();

    const handleCodeChange = (value: string, index: number) => {
        const updated = [...code];
        updated[index] = value;
        setCode(updated);
    };

    const handleSendCode = async () => {
        setIsSubmitting(true);
        try {
            const res = await axios.post(
                "https://ai.staging.app.familydoctor.com.au/verification/email",
                { email },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            console.log("Response:", res.data);
            setChallengeId(res.data.challengeId);


            setStep(2);
            setIsSubmitting(false);
        } catch (err) {
            console.error("Failed to send verification email:", err);
            showPopUpAlert({
                severity: "error",
                title: "Failed to send verification email",
                message: err?.response?.data?.message || err?.message || "Something went wrong"
            });
        }
    };


    return (
        <Flex justify="center" align="center" px={4}>
            <Box maxW="400px" width="100%">
                {/* {step === 1 && (
                    <VStack spacing={4} align="stretch" textAlign="center">
                        <Flex align="center" fontSize="sm">
                            <Checkbox mr={2} />
                            I agree to user&nbsp;
                            <Text as="span" color="blue.600" fontWeight="medium" cursor="pointer">
                                terms of use
                            </Text>
                            &nbsp;and&nbsp;
                            <Text as="span" color="blue.600" fontWeight="medium" cursor="pointer">
                                privacy policy
                            </Text>.
                        </Flex>

                        <Text fontSize="md" fontWeight="medium">Enter your e mail.</Text>

                        <Input
                            placeholder="Enter your e mail"
                            value={email}
                            borderRadius="30px"

                            onChange={(e) => setEmail(e.target.value)}

                        />

                        <Button
                            bg={servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg}
                            color="white"
                            borderRadius="30px"
                            h="44px"
                            fontWeight="bold"
                            onClick={() => setStep(2)}
                        >
                            Send code
                        </Button> */}

                {/* <Text fontSize="sm" color="gray.500">or</Text>

                        <Button
                            variant="outline"
                            leftIcon={<Image src="/google-logo.png" alt="Google" boxSize="18px" />}
                            borderRadius="30px"

                            borderColor={servicebookingFlowStore?.configurationDetails?.colorScheme?.inputBorder}
                            color={servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg}
                            border="2px"
                            h="44px"
                            fontWeight="medium"
                            justifyContent="center"
                        >
                            Signin via Google account
                        </Button>

                        <Button
                            variant="outline"
                            leftIcon={<Image src="/apple-logo.png" alt="Apple" boxSize="18px" />}
                            borderRadius="30px"
                            borderColor={servicebookingFlowStore?.configurationDetails?.colorScheme?.inputBorder}
                            color={servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg}
                            border="2px"
                            h="44px"
                            fontWeight="medium"
                            justifyContent="center"
                        >
                            Signin via Apple account
                        </Button> */}
                {/* </VStack>
                )} */}

                {step === 1 && (
                    <VStack spacing={4} align="stretch" textAlign="center" w="300px" mt={{ base: '100px', md: 0 }}>
                        <Flex align="center" fontSize="sm">
                            <Checkbox mr={2} isChecked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
                            I agree to the&nbsp;
                            <Text
                                as="span"
                                color="blue.600"
                                fontWeight="medium"
                                cursor="pointer"
                                onClick={() =>
                                    window.open("https://familydoctor.com.au/privacy-policy-family-doctor-2/", "_blank")
                                }
                            >
                                Privacy Policy
                            </Text>.
                        </Flex>

                        <Text fontSize="md" fontWeight="medium">Enter your email.</Text>

                        <Input
                            placeholder="Enter your email"
                            value={email}
                            borderRadius="30px"
                            isDisabled={!agreed}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <Button
                            isLoading={isSubmitting}
                            isDisabled={!agreed || !email}
                            bg={servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg}
                            color="white"
                            borderRadius="30px"
                            h="44px"
                            fontWeight="bold"
                            onClick={handleSendCode}
                        >
                            Send code
                        </Button>
                    </VStack>
                )}


                {step === 2 && (
                    <VStack spacing={4} w="350px" mt={{ base: '100px', md: 0 }}>
                        <Heading size="sm">Welcome MyGPOnline !</Heading>
                        <Text textAlign="center" fontSize="sm" fontWeight="bold">
                            Please check your email for the verification code we’ve just sent.
                        </Text>

                        <Text fontSize="sm" color="gray.500" textAlign="center">
                            It might take a moment to arrive, depending on your email provider.
                            If you don’t see it right away, try refreshing your inbox — and don’t forget to check your spam
                            or junk folder just in case!
                        </Text>
                        <Flex gap={2}>
                            {code.map((char, index) => (
                                <Input
                                    key={index}
                                    maxLength={1}
                                    type="tel"
                                    inputMode="numeric"
                                    ref={(el) => {
                                        codeInputRefs.current[index] = el;
                                    }}
                                    value={char}
                                    textAlign="center"
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        // If user pastes entire code (e.g., 6 digits at once)
                                        if (val.length === 6) {
                                            const chars = val.split('').slice(0, 6);
                                            setCode(chars);
                                            // Automatically move focus to last input
                                            codeInputRefs.current[5]?.focus();
                                        } else {
                                            handleCodeChange(val, index);
                                            if (val && index < codeInputRefs.current.length - 1) {
                                                codeInputRefs.current[index + 1]?.focus();
                                            }
                                        }
                                    }}

                                    onPaste={(e) => {
                                        const pasted = e.clipboardData.getData('text').trim();
                                        if (pasted.length === 6 && /^\d{6}$/.test(pasted)) {
                                            const chars = pasted.split('');
                                            setCode(chars);
                                            codeInputRefs.current[5]?.focus();
                                            e.preventDefault();
                                        }
                                    }}

                                    onKeyDown={(e) => {
                                        if (e.key === "Backspace" && !code[index] && index > 0) {
                                            codeInputRefs.current[index - 1]?.focus();
                                        }
                                    }}
                                />
                            ))}
                        </Flex>

                        {verificationError && (
                            <Text fontSize="sm" color="red.500" textAlign="center">
                                {verificationError}
                            </Text>
                        )}

                        <Button bg={servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg} borderRadius="30px" color="white" w="100%"
                            isDisabled={code.join('').length !== 6 || code.some(c => c.trim() === "")}
                            isLoading={isSubmitting}
                            onClick={async () => {
                                setIsSubmitting(true);
                                const verificationCode = code.join('');
                                if (verificationCode.length !== 6 || !challengeId) {
                                    console.error("Invalid code or missing challengeId");
                                    return;
                                }

                                const url = 'https://ai.staging.app.familydoctor.com.au/auth/verify-code';
                                const payload = {
                                    email: email,
                                    challengeId: challengeId,
                                    code: verificationCode
                                };

                                try {
                                    const response = await axios.post(url, payload, {
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    });
                                    console.log('Verification successful:', response.data);
                                    // const { accessToken, user } = response.data;
                                    // localStorage.setItem("accessToken", accessToken); 
                                    // patientStore.setCurrentPatient({
                                    //     id: null,
                                    //     first_name: user.first_name,
                                    //     last_name: user.last_name,
                                    //     dob: user.dob,
                                    //     contact_number: user.phone_number,
                                    //     is_new_pt: user.is_new_pt ?? "1",
                                    //     last_seen_did: user.last_seen_did ?? undefined,
                                    // });
                                    // console.log('Current Patient:', patientStore.currentPatient);
                                    // login(user, accessToken);
                                    // // setStep(3);
                                    // servicebookingFlowStore.goToAddress();

                                    const { accessToken, user, verified } = response.data;
                                    if (verified && !user) {
                                        setStep(3);
                                        return;
                                    }

                                    localStorage.setItem("accessToken", accessToken);
                                    // const patientUser = user;
                                    // const patientData = await getPatient({
                                    //     variables: {
                                    //         input: {
                                    //             clinic_group_crm: doctor.clinic_group_crm,
                                    //             user_fk: doctor.user_fk,
                                    //             location_id: doctor.location_id,
                                    //             dob: patientUser.dob,
                                    //             first_name: patientUser.first_name,
                                    //             last_name: patientUser.last_name,
                                    //             contact_number: patientUser.phone_number,
                                    //         },
                                    //     },
                                    // });

                                    const patientInfo = {
                                        id: null,
                                        type: "myself",
                                        first_name: user.first_name,
                                        last_name: user.last_name,
                                        dob: user.dob,
                                        contact_number: user.phone_number,
                                        is_new_pt: null,
                                        last_seen_did: null,
                                    };

                                    patientStore.setCurrentPatient(patientInfo);
                                    patientStore.setMainLoginPatient(patientInfo);
                                    console.log("patientInfo", patientInfo);


                                    login(user, accessToken);

                                    authStore.setAccessToken(accessToken || "");
                                    authStore.setEmail(email);
                                    authStore.setFirstName(user.firstName);
                                    authStore.setLastName(user.lastName);
                                    authStore.setPhone(user.phone);
                                    authStore.setCurrentUser(user);
                                    authStore.setUserName(user.username);

                                    const hasAddress =
                                        !!user?.patient_template?.Address1;

                                    if (hasAddress) {
                                        servicebookingFlowStore.setActiveStep(3);
                                        servicebookingFlowStore.goToConformation();
                                    } else {
                                        servicebookingFlowStore.setActiveStep(2);
                                        servicebookingFlowStore.goToAddress();
                                    }


                                } catch (err: any) {
                                    console.error("Verification failed:", err);
                                    if (err.response?.status === 400) {
                                        setVerificationError("Your code is wrong, please check your code and try again.");
                                    } else {
                                        setVerificationError("Something went wrong. Please try again later.");
                                    }
                                } finally {
                                    setIsSubmitting(false);
                                }

                            }}

                        >
                            Confirm
                        </Button>
                    </VStack>
                )}

                {step === 3 && (
                    <VStack spacing={4} align="stretch" mt={{ base: '100px', md: 0 }} minW={"310px"}>
                        <Heading size="md">Enter Personal Details</Heading>
                        <Text fontSize="sm">Input the following details to proceed with sign up</Text>
                        <Input
                            placeholder="Enter your First Name"
                            value={userDetails.firstName}
                            borderRadius="30px"
                            onChange={(e) =>
                                setUserDetails({ ...userDetails, firstName: e.target.value })
                            }
                        />
                        <Input
                            placeholder="Enter your Last Name"
                            value={userDetails.lastName}
                            borderRadius="30px"
                            onChange={(e) =>
                                setUserDetails({ ...userDetails, lastName: e.target.value })
                            }
                        />

                        <Text fontSize="sm">Select your Birthday</Text>

                        <DateOfBirthSelect
                            value={userDetails.dob}
                            onChange={(val) => setUserDetails({ ...userDetails, dob: val })}
                        />

                        <Select
                            placeholder="Select Gender"
                            borderRadius="30px"
                            color={'gray'}
                            value={userDetails.gender}
                            onChange={(e) =>
                                setUserDetails({ ...userDetails, gender: e.target.value })
                            }
                        >
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="NonBinary">NonBinary</option>
                            <option value="GenderDiverse">GenderDiverse</option>
                            <option value="Transgender">Transgender</option>
                            <option value="DifferentIdentity">Different Identity</option>
                        </Select>
                        <Button bg={servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg} borderRadius="30px" color="white" 
                            isDisabled={
                                !userDetails.firstName.trim() ||
                                !userDetails.lastName.trim() ||
                                !userDetails.dob ||
                                !userDetails.gender
                            }
                            onClick={() => setStep(4)}>
                            Next
                        </Button>
                    </VStack>
                )}

                {step === 4 && control && (
                    <VStack spacing={4} align="stretch" mt={{ base: '100px', md: 0 }} minW={'310px'}> 
                        <FormLabel>Mobile Number</FormLabel>
                        <Controller
                            name="mobileNumber"
                            control={control}
                            rules={{
                                required: "Mobile number is required",
                                validate: (value) => {
                                    const phoneNumber = parsePhoneNumberFromString(value, 'AU');
                                    return phoneNumber && phoneNumber.isValid()
                                        ? true
                                        : "Invalid phone number format";
                                },
                            }}
                            render={({ field: { onChange, value, ...rest }, fieldState }) => (
                                <>
                                    <InputGroup>
                                        <Input
                                            {...rest}
                                            value={value}
                                            borderRadius={30}
                                            placeholder="Enter your Phone Number"
                                            onBlur={(e) => {
                                                const input = e.target.value;
                                                const phoneNumber = parsePhoneNumberFromString(input, 'AU');
                                                if (phoneNumber && phoneNumber.isValid()) {
                                                    onChange(phoneNumber.formatInternational());
                                                } else {
                                                    onChange(input);
                                                }
                                            }}
                                            onChange={onChange}
                                        />
                                        <InputRightElement>
                                            <span role="img" aria-label="Australian Flag" style={{ fontSize: '1.5rem' }}>
                                                🇦🇺
                                            </span>
                                        </InputRightElement>
                                    </InputGroup>
                                    {fieldState.error && (
                                        <Text fontSize="sm" color="red.500">
                                            {fieldState.error.message}
                                        </Text>
                                    )}
                                </>
                            )}
                        />
                        <Button
                            bg={servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg}
                            borderRadius="30px"
                            color="white"
                            isDisabled={!isValid || isPhoneSubmitting}
                            isLoading={isPhoneSubmitting}
                            onClick={async () => {
                                setIsPhoneSubmitting(true);
                                try {
                                    const phone = getValues("mobileNumber");
                                    const formattedDob = userDetails.dob
                                        ? dayjs(userDetails.dob, 'YYYY-MM-DD').format('DD/MM/YYYY')
                                        : null;

                                    const userPayload = {
                                        challenge_id: challengeId,
                                        user: {
                                            first_name: userDetails.firstName,
                                            last_name: userDetails.lastName,
                                            email: email,
                                            dob: formattedDob,
                                            gender: userDetails.gender,
                                            phone_number: phone,
                                        },
                                    };

                                    const response = await axios.post(
                                        "https://ai.staging.app.familydoctor.com.au/users",
                                        userPayload,
                                        {
                                            headers: {
                                                "Content-Type": "application/json",
                                                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                                            },
                                        }
                                    );

                                    const user = response.data.user;
                                    console.log("User response:", user);
                                    await patientStore.setCurrentPatient({
                                        id: user.id,
                                        first_name: user.first_name,
                                        last_name: user.last_name,
                                        dob: user.dob,
                                        contact_number: user.phone_number,
                                        is_new_pt: "1",
                                        last_seen_did: null,
                                    });
                                    console.log("Current Patient:", patientStore.currentPatient);
                                    authStore.setAccessToken(response.data.access_token || "");
                                    authStore.setEmail(email);
                                    authStore.setFirstName(userDetails.firstName);
                                    authStore.setLastName(userDetails.lastName);
                                    authStore.setPhone(phone);
                                    authStore.setCurrentUser(user);
                                    authStore.setUserName(user.username);

                                    console.log("User created:", user);
                                    servicebookingFlowStore.setActiveStep(2);
                                    servicebookingFlowStore.goToAddress();
                                } catch (error) {
                                    console.error("User creation failed:", error);
                                } finally {
                                    setIsPhoneSubmitting(false);
                                }
                            }}
                        >
                            Next
                        </Button>


                    </VStack>
                )}

            </Box>
        </Flex>
    );
};

export default Step11_ServiceLogin;
